import { useState } from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { TourDefinition } from '@ui/components/Tourtip/Tourtip'

import { CommonPaths } from '@utils/path'

import { useFundingNav } from '@hooks/useFundingNav'

import { useDepositTracker } from '@analytics/amplitude/deposit'

import { markCompleted, markDismissed } from './store'
import { useOnTourStart } from './useOnTourStart'
import { useTourOrchestration } from './useTourOrchestration'

export const useTourHost = () => {
  const [activeTour, setActiveTour] = useState<TourDefinition | null>(null)
  const navigate = useNavigate()
  const { navigateToFunding } = useFundingNav()
  const tracker = useDepositTracker()

  useTourOrchestration()
  useOnTourStart(setActiveTour)

  const handleClose = () => {
    if (activeTour) {
      markDismissed(activeTour.id)
    }
    setActiveTour(null)
  }

  const handleComplete = () => {
    if (activeTour) {
      markCompleted(activeTour.id)
    }
    setActiveTour(null)
  }

  const handleCommand = (command?: string) => {
    if (command === 'wallets.outro.deposit') {
      tracker.start({ entry_point: 'tour_guide' })
      navigateToFunding(`${CommonPaths.Deposit}/wallet`)
      handleComplete()
      return
    }
    if (command === 'tradingAccounts.outro.create') {
      navigate(CommonPaths.NewLiveTradingAccount)
      if (activeTour) {
        markCompleted(activeTour.id)
      }
    }
    handleComplete()
  }

  return {
    activeTour,
    handleClose,
    handleCommand,
    handleComplete,
  }
}
